import types from '../types'
import Action from '../../types/Action'

const initialState = {
  users: {
	  loading: true,
    data: []
  },
  addUser: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  updateUser: {
    loading: false,
    success: false,
    error: false,
    data: []
  },
  roles: {
  	loading: true,
    data: []
  },
  providers: {
	  loading: true,
    data: []
  },
  providerUserExists: {
    loading: false,
    success: false,
    error: false,
    data: []
  }
}

const userAccountReducer = (state = initialState, action: Action) => {
  switch (action.type) {
  	case types.GET_USERS_REQUESTED: {
      return {
        ...state,
        users: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_USERS_FULFILLED: {
      return {
        ...state,
        users: {
		      ...state.users,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_USERS_REJECTED: {
      return {
        ...state,
        users: {
	    	  ...state.users,
          loading: false,
          error: action.payload
        }
      }
    }
	  case types.ADD_USER_REQUESTED: {
      return {
        ...state,
        addUser: {
          loading: true,
          error: false,
          success: false,
	    	  data: []
        }
      }
    }
    case types.ADD_USER_FULFILLED: {
      return {
        ...state,
        addUser: {
	    	  ...state.addUser,
          loading: false,
          success: true,
          data: action.payload
        },
        users: {
          ...state.users,
          data: [
            ...state.users.data,
            action.payload
          ]
        }
      }
    }
  	case types.ADD_USER_REJECTED: {
      return {
        ...state,
        addUser: {
    		  ...state.addUser,
          loading: false,
          error: action.payload
        }
      }
    }
  	case types.UPDATE_USER_REQUESTED: {
      return {
        ...state,
        updateUser: {
          loading: true,
          error: false,
          success: false,
	    	  data: []
        }
      }
    }
    case types.UPDATE_USER_FULFILLED: {
      const index = state.users.data.findIndex((user) => user.user_id === action.payload.user_id)
      return {
        ...state,
        updateUser: {
    		  ...state.updateUser,
          loading: false,
          success: true,
          data: action.payload
        },
        users: {
          ...state.users,
          data: [
            ...state.users.data.slice(0, index),
            action.payload,
            ...state.users.data.slice(index + 1)
          ]
        }
      }
    }
	  case types.UPDATE_USER_REJECTED: {
      return {
        ...state,
        updateUser: {
		      ...state.updateUser,
          loading: false,
          error: action.payload
        }
      }
    }
	  case types.GET_ROLES_REQUESTED: {
      return {
        ...state,
        roles: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_ROLES_FULFILLED: {
      return {
        ...state,
        roles: {
	    	  ...state.roles,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_ROLES_REJECTED: {
      return {
        ...state,
        roles: {
		     ...state.roles,
          loading: false,
          error: action.payload
        }
      }
    }
  	case types.GET_PROVIDERS_REQUESTED: {
      return {
        ...state,
        providers: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_PROVIDERS_FULFILLED: {
      return {
        ...state,
        providers: {
		  ...state.providers,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_PROVIDERS_REJECTED: {
      return {
        ...state,
        providers: {
		     ...state.providers,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.VALIDATE_PROVIDER_ADMIN_USER_REQUESTED: {
      return {
        ...state,
        providerUserExists: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.VALIDATE_PROVIDER_ADMIN_USER_FULFILLED: {
      return {
        ...state,
        providerUserExists: {
		      ...state.providerUserExists,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
  	case types.VALIDATE_PROVIDER_ADMIN_USER_REJECTED: {
      return {
        ...state,
        providerUserExists: {
		      ...state.providerUserExists,
          loading: false,
          error: action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}

export default userAccountReducer